export const FETCH_DEDUCTIONS = "FETCH_DEDUCTIONS";
export const FETCH_DEDUCTIONS_SUCCESS = "FETCH_DEDUCTIONS_SUCCESS";
export const FETCH_DEDUCTIONS_FAILURE = "FETCH_DEDUCTIONS_FAILURE";

export const CREATE_DEDUCTION_REQUEST = "CREATE_DEDUCTION_REQUEST";
export const CREATE_DEDUCTION_SUCCESS = "CREATE_DEDUCTION_SUCCESS";
export const CREATE_DEDUCTION_FAILURE = "CREATE_DEDUCTION_FAILURE";

export const CHANGE_DEDUCTION_STATUS = "CHANGE_DEDUCTION_STATUS";
export const CHANGE_DEDUCTION_STATUS_SUCCESS = "CHANGE_DEDUCTION_STATUS_SUCCESS";
export const CHANGE_DEDUCTION_STATUS_FAILURE = "CHANGE_DEDUCTION_STATUS_FAILURE";

export const DELETE_DEDUCTION = "DELETE_DEDUCTION";
export const DELETE_DEDUCTION_SUCCESS = "DELETE_DEDUCTION_SUCCESS";
export const DELETE_DEDUCTION_FAILURE = "DELETE_DEDUCTION_FAILURE";
